import { render, staticRenderFns } from "./TransferPlacesUpdateForm.vue?vue&type=template&id=2dadd99f&"
import script from "./TransferPlacesUpdateForm.vue?vue&type=script&lang=js&"
export * from "./TransferPlacesUpdateForm.vue?vue&type=script&lang=js&"
import style0 from "./TransferPlacesUpdateForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports